import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { seriesItems } from "@/mocks/movies";

const barMap: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

const badgeMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function SeriesSection() {
  return (
    <section id="series" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="剧集与综艺"
            title="适合连续追更的长内容"
            desc="除了单部影片，站内也整理了适合按集观看的剧集、综艺与纪录片。下表标注了集数、更新状态与内容侧重，方便你安排追更节奏。"
          />
        </Reveal>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {seriesItems.map((item, index) => (
            <Reveal key={item.id} delay={(index % 3) * 70}>
              <article className="h-full flex gap-4 rounded-lg bg-background-100 border border-background-200 p-5">
                <span className={`w-1 rounded-full ${barMap[item.tone]}`}></span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                    <span className={`shrink-0 px-2 py-0.5 rounded-md text-[11px] font-medium ${badgeMap[item.tone]}`}>
                      {item.kind}
                    </span>
                  </div>
                  <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                    <span><i className="ri-stack-line mr-1"></i>{item.episodes}</span>
                    <span><i className="ri-refresh-line mr-1"></i>{item.status}</span>
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}